import React from 'react';

const MailInCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="156"
    height="156"
    viewBox="0 0 156 156"
  >
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#FFF"
        strokeWidth="4.5"
        d="M77.917 152.834c41.375 0 74.917-33.542 74.917-74.917C152.834 36.54 119.292 3 77.917 3 46.26 3 19.19 22.634 8.22 50.388 4.85 58.91 3 68.198 3 77.917c0 38.636 29.248 70.442 66.81 74.483 2.663.287 5.368.434 8.107.434z"
      />
      <path
        fill="#FFF"
        d="M37.111 51.889v52.222h81.778V51.89H37.11zm40.89 32.25L44.457 55.762h67.084L78 84.138zM64.638 77.99L41.132 97.877V58.104l23.507 19.887zm3.047 2.578l10.313 8.725 10.314-8.725 23.25 19.668H44.437L67.686 80.57zm23.674-2.577l23.508-19.888v39.773L91.36 77.992z"
      />
    </g>
  </svg>
);

export default MailInCircleIcon;
